import {request} from '@/helpers/apiClient'
import {INVENTORY_CONFIG} from '@/utils/constants/apiConfig/Fulfillment/inventoryConfig'
import {HTTP_METHODS} from '@/utils/constants/httpMethods'

export const getInventory = (body, queryParams) => request(INVENTORY_CONFIG.INVENTORY(queryParams), {data: body})

export const getInventoryUploadHistory = (type, queryString = '') => {
  const baseEndpoint = `file/metadata?templateType=${type}`

  const endPoint = queryString ? `${baseEndpoint}&${queryString}` : baseEndpoint

  return request(
    {
      endPoint,
      method: HTTP_METHODS.GET,
      baseUrlKey: 'inventoryApiUrl',
    },
    {}
  )
}

export const getInventoryCsvFile = (body, queryParams = '') =>
  request(INVENTORY_CONFIG.INVENTORY_CSV_DOWNLOAD(queryParams), {data: body})
export const getInventoryFileUploadErrors = (id, header) =>
  request(INVENTORY_CONFIG.INVENTORY_FILE_UPLOAD_ERRORS(id), {
    headers: {Accept: header ? header : 'application/json'},
  })
